import { Pipe, PipeTransform } from '@angular/core';
import { ConsolidatedTask, TaskType } from '../models/task';

export type TaskNavigationInput = Pick<
  ConsolidatedTask.Model,
  'entityType' | 'entityId' | 'taskType'
>;

@Pipe({
  name: 'taskNavigationUrl'
})
export class TaskNavigationUrlPipe implements PipeTransform {
  transform(task: TaskNavigationInput): string[] {
    switch (task.entityType) {
      case ConsolidatedTask.EntityType.Company:
        return ['/Contacts', 'Company', task.entityId, 'Tasks'];
      case ConsolidatedTask.EntityType.Individual:
        return ['/Contacts', 'Individual', task.entityId, 'Tasks'];
      case ConsolidatedTask.EntityType.Trust:
        return ['/Contacts', 'Trust', task.entityId, 'Tasks'];
      case ConsolidatedTask.EntityType.Lead:
        return ['/Leads', task.entityId];
      case ConsolidatedTask.EntityType.Opportunity:
        return this.opportunityNavigationUrl(task);
      default:
        return [];
    }
  }

  private opportunityNavigationUrl(task: TaskNavigationInput): string[] {
    switch (task.taskType) {
      case TaskType.FactFindDocumentsPublished:
        return ['/Opportunities', task.entityId, 'fact-find', 'documents'];
      case TaskType.FactFindAttested:
        return ['/Opportunities', task.entityId, 'fact-find'];
      default:
        return ['/Opportunities', task.entityId, 'Tasks'];
    }
  }
}
